import React, { useState } from "react";
import "./Faq.css";
import Webhook from "../../assets/svg/webhook.svg";
import Arrow from "../../assets/svg/arrow.svg";
import Gloss from "../../assets/svg/gloss.svg";
import Notes from "../../assets/svg/notes.svg";
import Docs from "../../assets/svg/doc.svg";
import ChatWindow from "../../components/ChatWindow";
import ChatIcon from "../../assets/svg/chat-icon.svg";
import { Link } from "react-router-dom";

function Faq() {
  const [isChatOpen, setIsChatbotOpen] = useState(false);

  const toggleChat = () => {
    setIsChatbotOpen(!isChatOpen);
  };

  return (
    <div className="faq">
      <header className="faq-header">
        <div className="faq-background"></div>
        <div className="faq-content">
          <h1>Precisa de Ajuda?</h1>
          <p>
            Se você precisar de assistência adicional, envie um&nbsp; 
            <a
              href="https://atendimento.spcgrafeno.com.br/support/tickets/new"
              target="_blank"
              rel="noopener noreferrer"
            >
               ticket 
            </a>
            &nbsp;no nosso formulário de suporte e a SPC Grafeno abrirá um chamado
            para melhor atendê-lo. Para atendimento via telefone, ligue para
            4020-1665. Você também pode ser atendido via e-mail, enviando sua
            solicitação para &nbsp;
            <a href="mailto:backoffice@spcgrafeno.com.br">
              backoffice@spcgrafeno.com.br
            </a>
          </p>
        </div>
      </header>
      <main className="faq-main">
        <h3>Como podemos te ajudar? </h3>
        <section className="faq-cards">
          <div className="faq-card">
            <img src={Docs} alt="Guia" />
            <h2>Documentação API</h2>
            <p>
              Acesse todas as informações que você precisa para integrar e
              utilizar nossa API de forma eficiente. Clique aqui para conferir a
              documentação completa!
            </p>
            <div className="faq-card-btn">
              <button>
                <Link to="/registrativos#/893gi9lwxfmlh-introducao">
                  Acessar
                  <img src={Arrow} alt="Arrow" />
                </Link>
              </button>
            </div>
          </div>
          <div className="faq-card">
            <img src={Webhook} alt="Guia" />
            <h2>Webhooks</h2>
            <p>
              Automatize e integre facilmente com nossas novas funcionalidades
              de webhooks. Clique aqui para saber mais e comece a conectar suas
              aplicações.
            </p>
            <div className="faq-card-btn">
              <button>
                <Link to="/registrativos#/lkjmk994m6lb7-webhook-do-sistema-spc-grafeno">
                  Acessar
                  <img src={Arrow} alt="Arrow" />
                </Link>
              </button>
            </div>
          </div>

          <div className="faq-card">
            <img src={Gloss} alt="Guia" />
            <h2>Glossários</h2>
            <p>
              Simplifique seu entendimento com nosso glossário completo de
              termos e definições.
            </p>
            <div className="faq-card-btn">
              <button>
                <Link to="/registrativos#/l2ggiqyqgpjx2-glossario">
                  Acessar
                  <img src={Arrow} alt="Arrow" />
                </Link>
              </button>
            </div>
          </div>
          <div className="faq-card">
            <img src={Notes} alt="Guia" />
            <h2>Release notes</h2>
            <p>
              Confira as últimas atualizações e melhorias no nosso produto.
              Clique aqui para acessar as Release Notes e ficar por dentro de
              tudo o que mudou!
            </p>
            <div className="faq-card-btn">
              <button className="rn" disabled>
                Em breve
                {/* <Link to="docs#lkqp8tgn70zk7-release-notes">
                  <img src={Arrow} alt="Arrow" />
                </Link> */}
              </button>
            </div>
          </div>
        </section>
      </main>
      <div className="chat-icon" onClick={toggleChat}>
        <img src={ChatIcon} alt="Chat Icon" />
      </div>
      <ChatWindow isOpen={isChatOpen} toggleChat={toggleChat} />
    </div>
  );
}

export default Faq;
